export default "__VITE_ASSET__Ce3Oo15N__"